export default __webpack_public_path__ + "static/media/muokkaus.a463628f.png";